import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import { getTranslation } from 'common/react/utils/translations';
import { TooltipButton } from 'common/react/components/tooltip-button';
import { SvgIcon } from 'common/react/components/SvgIcon';
import { TeamLineupsContext } from 'widgets/mc-team-lineups/js/components/MCTeamLineups';

export const LateChanges = ({ match, teamDisplay, selectedTabView }) => {
    const { homeTeam, awayTeam } = match.matchRoster;
    const teamLineupsContext = useContext(TeamLineupsContext);

    const renderTitle = (classes) => (
        <div
            className={`team-lineups__title-section team-lineups-late-changes__title-section ${classes}`}
        >
            {!homeTeam.lateChanges && !awayTeam.lateChanges ? (
                <div className="team-lineups-late-changes__title-wrapper team-lineups-late-changes__title-wrapper--no-changes">
                    <span>
                        {getTranslation('label.teamlineups.noLateChanges')}
                    </span>
                    <TooltipButton
                        id={`team-lineups-late-changes`}
                        title="Late changes tooltip"
                        primaryTooltipContent={getTranslation(
                            'label.teamLineups.lateChanges.tooltip'
                        )}
                    >
                        <SvgIcon
                            icon="info-circle"
                            className="team-lineups__tooltip-icon"
                        />
                    </TooltipButton>
                </div>
            ) : (
                <div className="team-lineups-late-changes__title-wrapper">
                    <span className="team-lineups__title">
                        {getTranslation('label.teamlineups.lateChanges.short')}
                    </span>
                    <TooltipButton
                        id={`team-lineups-late-changes`}
                        title="Late changes tooltip"
                        primaryTooltipContent={getTranslation(
                            'label.teamLineups.lateChanges.tooltip'
                        )}
                    >
                        <SvgIcon
                            icon="info-circle"
                            className="team-lineups__tooltip-icon"
                        />
                    </TooltipButton>
                </div>
            )}
        </div>
    );

    return (
        <div
            className={`team-lineups-ins-and-outs ${
                (teamDisplay === PULSE.app.common.CONSTANTS.TEAM.HOME ||
                    teamDisplay === PULSE.app.common.CONSTANTS.TEAM.AWAY) &&
                selectedTabView === PULSE.app.common.CONSTANTS.VIEWS.FIELD
                    ? 'team-lineups-ins-and-outs--single'
                    : ''
            }`}
        >
            {teamLineupsContext === 'match-centre' &&
            !homeTeam.lateChanges &&
            !awayTeam.lateChanges ? (
                renderTitle(
                    'mc-team-lineups__late-changes mc-team-lineups__late-changes--none'
                )
            ) : (
                <>
                    {renderTitle('u-hide-from-tablet')}
                    <div
                        className={`team-lineups__grid team-lineups__grid--${teamDisplay}`}
                    >
                        {(teamDisplay ===
                            PULSE.app.common.CONSTANTS.TEAM.HOME ||
                            teamDisplay ===
                                PULSE.app.common.CONSTANTS.TEAM.BOTH ||
                            selectedTabView ===
                                PULSE.app.common.CONSTANTS.VIEWS.LIST) && (
                            <div className="team-lineups__event-text team-lineups__event-text--home">
                                {homeTeam.lateChanges ? (
                                    <span>{homeTeam.lateChanges}</span>
                                ) : (
                                    <span className="team-lineups-ins-and-outs__empty">
                                        &ndash;
                                    </span>
                                )}
                            </div>
                        )}

                        {renderTitle('u-hide-until-tablet')}
                        {(teamDisplay ===
                            PULSE.app.common.CONSTANTS.TEAM.AWAY ||
                            teamDisplay ===
                                PULSE.app.common.CONSTANTS.TEAM.BOTH ||
                            selectedTabView ===
                                PULSE.app.common.CONSTANTS.VIEWS.LIST) && (
                            <div className="team-lineups__event-text team-lineups__event-text--away">
                                {awayTeam.lateChanges ? (
                                    <span>{awayTeam.lateChanges}</span>
                                ) : (
                                    <span className="team-lineups-ins-and-outs__empty">
                                        &ndash;
                                    </span>
                                )}
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

LateChanges.propTypes = {
    match: PropTypes.object.isRequired,
    teamDisplay: PropTypes.string.isRequired,
    selectedTabView: PropTypes.string.isRequired
};
